// src/i18n/en/events.ts

/**
 * English translations for Events feature
 */
const events = {
  name: 'Events',
  title: 'Events',

  // Help
  help: {
    page: "View all system events including operations, heartbeats, and errors. Use filters to find specific events or search by metadata. «From» and «To» are the property's days: each day runs from the property's day-closing time (04:00 unless it states another) to the same time the next day, in its time zone.",
  },

  // Fields
  fields: {
    createdAt: 'Date/Time',
    eventCode: 'Event Type',
    device: 'Device',
    reservation: 'Reservation',
    hotel: 'Property',
    channel: 'Channel',
    status: 'Status',
    metadata: 'Metadata',
    errorCode: 'Error Code',
  },

  // Filters
  filters: {
    reservation: 'Search by reservation',
    roomNumber: 'Search by room',
    group: 'Group',
    allGroups: 'All Groups',
    hotel: 'Property',
    device: 'Device',
    eventCode: 'Event Type',
    channel: 'Channel',
    status: 'Status',
    dateFrom: 'Date from',
    dateTo: 'Date to',
    showHeartbeats: 'Show Heartbeats',
    showFilters: 'Show filters',
  },

  // Event codes
  eventCodes: {
    // Legacy short codes
    HB: 'Heartbeat',
    PCO: 'Pre Check-in Opened',
    PCF: 'Pre Check-in Finished',
    CIO: 'Check-in Opened',
    CIF: 'Check-in Finished',
    KDO: 'Key Dispensing Opened',
    KDF: 'Key Dispensing Finished',
    ERR: 'Error',
    COO: 'Check-out Opened',
    COF: 'Check-out Finished',

    // Check-in flow
    CI_START: 'Check-in started',
    CI_SEARCH: 'Reservation search',
    CI_IDENTIFY: 'Guest identification',
    CI_SIGN: 'Signature',
    CI_UPSELL: 'Upsell',
    CI_COMP: 'Check-in completed',

    // Pre-check-in flow
    PC_LINK_OPEN: 'Link opened',
    PC_START: 'Pre-check-in started',
    PC_SEARCH: 'Reservation search',
    PC_IDENTIFY: 'Guest identification',
    PC_SIGN: 'Signature',
    PC_UPSELL: 'Upsell',
    PC_COMP: 'Pre-check-in completed',

    // Section navigation
    SECTION_ENTER: 'Section entered',
    SECTION_EXIT: 'Section exited',

    // Payment
    PM_SUCCESS: 'Payment completed',
    PM_ERROR: 'Payment error',

    // Key delivery
    KD_SUCCESS: 'Key delivered',
    KD_ERROR: 'Key delivery error',
    KD_REBOOT: 'Dispenser restart',

    // Operational / errors
    PMS_RECOVERY_FAILED: 'Recovery failed',
    PMS_RESERVATION_NOT_FOUND: 'Reservation not found',
    PMS_ROOM_NOT_READY: 'Room not ready',
    AB: 'Session abandoned',
  },

  // Channels
  channels: {
    Kiosk: 'Kiosk',
    Dispenser: 'Key dispenser',
    Online: 'Online pre-check-in',
    AirLobby: 'Air Lobby',
    MobileKiosk: 'Mobile kiosk',
  },

  // Status
  status: {
    completed: 'Completed',
    started: 'Started',
    error: 'Error',
    unknown: 'Unknown',
  },

  // Metadata
  metadata: {
    title: 'Event Metadata',
    view: 'View metadata',
    copyJson: 'Copy as JSON',
    empty: 'No metadata available',
    searchTitle: 'Search by Metadata',
    searchDescription: 'Find events that contain a specific metadata key and value.',
    searchButton: 'Search by Metadata',
    searchActive: 'Searching events with metadata: %{key} = %{value}',
    key: 'Metadata Key',
    value: 'Metadata Value',
    keyRequired: 'Metadata key is required',
    valueRequired: 'Metadata value is required',
    dateRange: 'Date Range (optional)',
    expand: 'Expand metadata',
    collapse: 'Collapse metadata',
  },

  // Errors
  errors: {
    loadFailed: 'Failed to load events',
  },

  // Bulk delete (SuperAdmin)
  bulkDelete: {
    deleteSelected: 'Delete Selected',
    deleteByFilters: 'Delete all matching filters',
    confirmTitle: 'Confirm Deletion',
    confirmMessage: 'You are about to permanently delete %{count} event. This action cannot be undone. |||| You are about to permanently delete %{count} events. This action cannot be undone.',
    confirmByFiltersMessage: 'You are about to permanently delete ALL events matching the current filters. This action cannot be undone.',
    irreversible: 'This action is irreversible. Deleted events cannot be recovered.',
    deleting: 'Deleting...',
    successMessage: '%{count} event deleted successfully |||| %{count} events deleted successfully',
    errorMessage: 'Failed to delete events',
    selected: '%{count} selected',
    clearSelection: 'Clear selection',
    selectAll: 'Select all',
  },
};

export default events;
